import { render, staticRenderFns } from "./LicenseAgreement.vue?vue&type=template&id=4daf312c&scoped=true&"
import script from "./LicenseAgreement.vue?vue&type=script&lang=js&"
export * from "./LicenseAgreement.vue?vue&type=script&lang=js&"
import style0 from "./LicenseAgreement.vue?vue&type=style&index=0&id=4daf312c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daf312c",
  null
  
)

export default component.exports